import React from 'react';

export const SuccessIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
  </svg>
);

export const ErrorIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
  </svg>
);

export const WarningIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
  </svg>
);

export const InfoIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
  </svg>
);

export const InfoIconSecondary: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path fill="#677a89" d="M10 1.876a8.125 8.125 0 1 1 0 16.25 8.125 8.125 0 0 1 0-16.25m1.219 4.988c.603 0 1.093-.419 1.093-1.04 0-.62-.491-1.04-1.093-1.04-.604 0-1.091.42-1.091 1.04s.487 1.04 1.09 1.04m.212 6.531c0-.124.043-.447.019-.63l-.954 1.098c-.198.207-.445.351-.561.313a.236.236 0 0 1-.15-.267l1.59-5.023c.13-.637-.227-1.219-.985-1.293-.8 0-1.977.811-2.693 1.84 0 .124-.023.43.001.614l.953-1.1c.198-.205.427-.35.544-.31a.23.23 0 0 1 .141.292L7.76 13.928c-.182.585.162 1.158.998 1.288 1.23 0 1.957-.791 2.674-1.821"/>
  </svg>
);

export const CloseIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
  </svg>
);

